import React from 'react';
import axios from 'axios';

// Convert base64 VAPID public key to Uint8Array (required by Chromium-based browsers)
export function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
}

export const subscribeUserToPush = async (gardenerID, vapidPublicKey) => {
    try {

        if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
            console.warn('Push not supported');
            return null;
        }

    const registration = await navigator.serviceWorker.ready;

    const existing = await registration.pushManager.getSubscription();
    if (existing) {
        console.log('User already subscribed to push.');
        // Still ensure backend has it
        await axios.post('/api/main/save-subscription', {
            gardenerID,
            subscription: existing.toJSON()
        });
      return existing;
    }

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
    });

        await axios.post('/api/main/save-subscription', {
            gardenerID,
            subscription: subscription.toJSON()
        });

    console.log('Push subscription saved.');
    return subscription;
  } catch (err) {
    console.error('Error subscribing user to push:', err);
    return null;
  }
};

//  Format phone number as (123) 456-7890
export const formatPhoneNumber = (phoneNumber) => {
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phoneNumber;
};

//  Format timestamp as 'Oct 17, 2026'
export const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-CA', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
};

//  Get placeholder text based on expected answer type
export const getPlaceholder = (type) => {
    switch (type?.toLowerCase()) {
        case 'int':
        case 'na or int':
            return 'Enter a whole number or "NA"';
        case 'float':
        case 'na or float':
            return 'Enter a decimal or "NA"';
        case 'date':
            return 'Select a date';
        case 'yesno':
            return ''; // dropdowns don�t need placeholders
        default:
            return `Answer (${type})`;
    }
};

//  Render input field based on expected answer type
export const renderInputField = ({ expectedAnswer, value, onChange, eventType, plantingMethod }) => {
    const type = expectedAnswer?.toLowerCase();
    const placeholder = getPlaceholder(type);
    const commonProps = {
        id: 'task-answer',
        value,
        onChange
    };
    console.log("type, eventType, and plantingMethod values: ", type, eventType, plantingMethod);
    if (type === 'yesno') {

    if (eventType === 'Planting' && plantingMethod === 'Start indoors') {
        return (
            <select {...commonProps}>
                <option value="">Select</option>
                <option value="Yes">
                    Yes
                </option>
                <option value="No - I plan to buy starter plants">
                    No - I plan to buy starter plants
                </option>
            </select>
        );
    }

    if (eventType === 'Planting' && plantingMethod === 'Direct sow') {
        return (
            <select {...commonProps}>
                <option value="">Select</option>
                <option value="Yes">
                    Yes
                </option>
                <option value="No - I'm not planting this window">
                    No - I'm not planting this window
                </option>
            </select>
        );
    }

    if (eventType === 'Planting' && plantingMethod === 'DS succession') {
        return (
            <select {...commonProps}>
                <option value="">Select</option>
                <option value="Yes">
                    Yes
                </option>
                <option value="No - I'm not planting anymore">
                    No - I'm not planting anymore
                </option>
            </select>
        );
    }

    // All other yes/no questions
        return (
            <select {...commonProps}>
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
            </select>
        );
    }

    if (type === 'date') {
        return <input type="date" {...commonProps} />;
    }

    if (type === 'int' || type === 'na or int') {
        return <input type="number" placeholder={placeholder} {...commonProps} />;
    }

    if (type === 'float' || type === 'na or float') {
        return <input type="text" placeholder={placeholder} {...commonProps} />;
    }

    return <input type="text" placeholder={placeholder} {...commonProps} />;
};
